/**
 * Widget Configuration
 *
 * Centralized configuration for all widgets.
 * Uses Vite environment variables (VITE_* prefix).
 */

/**
 * Get required environment variable
 * Throws error if not set
 */
function getRequiredEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${key}\n` +
      `Please add it to your .env file.\n` +
      `Example: ${key}=http://localhost:8000`
    );
  }
  return value;
}

/**
 * Normalize server URL by adding https:// if protocol is missing
 */
function normalizeServerUrl(url: string): string {
  // If URL doesn't have protocol, add https://
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  return url;
}

/**
 * Server URL for API requests
 * Required in both development and production
 * Uses VITE_MCP_SERVER_URL for compatibility with existing codebase
 * Automatically adds https:// if protocol is missing
 */
export const SERVER_URL = normalizeServerUrl(getRequiredEnv('VITE_MCP_SERVER_URL'));

/**
 * Development mode flag
 */
export const IS_DEV = import.meta.env.DEV;

/**
 * Production mode flag
 */
export const IS_PROD = import.meta.env.PROD;

/**
 * Full config object
 */
export const config = {
  serverUrl: SERVER_URL,
  isDev: IS_DEV,
  isProd: IS_PROD,
} as const;

// Log config on load (only in development)
if (IS_DEV) {
  console.log('[Widget Config]', config);
}
